module.exports = __webpack_public_path__ + "028556772653f7c1cbf68317e1fb5e4f.otf";